import { render, staticRenderFns } from "./CurrenciesModal.vue?vue&type=template&id=7c33359e&scoped=true"
import script from "./CurrenciesModal.vue?vue&type=script&lang=ts"
export * from "./CurrenciesModal.vue?vue&type=script&lang=ts"
import style0 from "./CurrenciesModal.vue?vue&type=style&index=0&id=7c33359e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c33359e",
  null
  
)

export default component.exports